import { apiPostService } from './baseApi.service';

export default function logConversion(conversionIdentifier) {
  return (async () => apiPostService('/api/conversion/logconversion', conversionIdentifier))();
}
